module.exports = __webpack_public_path__ + "static/media/ivone.931a51a1.jpg";